module.exports = __webpack_public_path__ + "img/mw.3bfa20a6.svg";